import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchMatchProfile = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, matchProfileId } = useParams();

  return useQuery({
    queryKey: ["matchProfiles", sport, organizationId, matchProfileId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/fixtureProfiles/${matchProfileId}`,
      });
      return result?.data?.[0];
    },
    enabled: !!matchProfileId,
  });
};

export const useFetchMatchProfiles = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/fixtureProfiles`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["matchProfiles", sport, organizationId, JSON.stringify(params)],
    queryFn: async () => {
      const result = await fetchData({
        url: URL,
      });
      return result?.data || [];
    },
  });
};
